import user from './slices/user.slice';
import popups from './slices/popups.slice';
import ui from './slices/ui.slice';

export const reducers = {
  user,
  popups,
  ui,
};
